import { Textarea } from '@/contasis';

interface CampoComentarioBreveProps {
  etiqueta: string;
  valor: string;
  onChange: (valor: string) => void;
  placeholder: string;
  maximoCaracteres: number;
  filas?: number;
  disabled?: boolean;
}

export function CampoComentarioBreve({
  etiqueta,
  valor,
  onChange,
  placeholder,
  maximoCaracteres,
  filas = 3,
  disabled = false,
}: CampoComentarioBreveProps) {
  return (
    <Textarea
      label={etiqueta}
      value={valor}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      maxLength={maximoCaracteres}
      showCharCount
      rows={filas}
      disabled={disabled}
    />
  );
}
